import React, { useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IssuedCertificates from "../components/issuedCertificates";
import { BackArrow } from "../constants";
import { useAppDispatch } from "../hooks/useSelector"; 
import { fetchIssuedCertificatesData } from "../store/slices/pendingRequests"; 
import { ROLES } from "../constants/textconstants";


interface UserData {
    userId: string;
    role: string;
    squads?: { code: string }[];
    units?: { code: string }[];
    territories?: { code: string }[];
}

const IssuedCertificatesPage: React.FC = () => {

  const handleYearChange = (year: string) => {
    console.log("Fetch data for year:", year);
  };

  return (
    <div
      style={{
        background: 'rgb(236, 239, 241)',
        padding: 30,
        paddingTop: 100,
        paddingBottom: 80,
      }}
    >
      <IssuedCertificates
        onYearChange={handleYearChange}
        showHeaderActions={true}
      />
    </div>
  );
};

export default IssuedCertificatesPage;
